module.exports = __webpack_public_path__ + "img/equipos-moviles-basica.df846252.jpg";